import { ProviderSource, TemplateType } from '@/modules/ab-testing/types/template';

export const PREFIX_DUPLICATE_NAME = 'Copy of';

export const TEMPLATE_ORIGIN: TemplateType[] = [
  TemplateType.COLLECTION,
  TemplateType.PRODUCT,
  TemplateType.HOME,
  TemplateType.ARTICLE,
  TemplateType.PAGE,
  TemplateType.BLOG,
];

export const TEMPLATE_SHOPIFY: ProviderSource[] = [
  ProviderSource.SHOPIFY,
  ProviderSource.SHOPIFY_GEMX,
  ProviderSource.SHOPIFY_ORIGIN,
];
